import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useVenue } from '@core/contexts/VenueContext';
import { useProfile } from '@core/contexts/ProfileContext';
import { coreRuntime } from '@core/runtime';

/**
 * Подвал обоих входов: название заведения, «Мои данные» (удаление данных, K-025) и — там, где вход это умеет
 * (PWA, capabilities.logout), — «Выйти». В Telegram сессию завершать некуда, поэтому в мини-аппе «Выйти» нет.
 */
export function VenueFooter() {
  const { venue } = useVenue();
  const { user } = useProfile();
  const [leaving, setLeaving] = useState(false);
  const rt = coreRuntime();
  const canLogout = rt.capabilities.logout && typeof rt.logout === 'function' && !!user;

  const handleLogout = async () => {
    if (!rt.logout || leaving) return;
    setLeaving(true);
    try {
      await rt.logout();
    } finally {
      setLeaving(false);
    }
  };

  return (
    <>
      {venue && <div className="text-center py-4 text-sm text-text-muted">{venue.name}</div>}
      {user && (
        <div className="text-center pb-3">
          <Link to="/my-data" className="text-sm text-text-muted underline">
            Мои данные
          </Link>
        </div>
      )}
      {canLogout && (
        <div className="text-center pb-6">
          <button
            type="button"
            onClick={() => void handleLogout()}
            disabled={leaving}
            className="text-sm text-text-muted underline disabled:opacity-50"
          >
            Выйти
          </button>
        </div>
      )}
    </>
  );
}
